import { InfoBadge } from 'ui/badge';
import { useTranslation } from 'modules/domains/list';
import { CellProps } from './types';
import { StyledTableCell } from './styles';

export const TypeCell = ({ row: list }: CellProps) => {
  const { t } = useTranslation();
  const listType = t(`indexPage.listTypes.${list.listType}`);
  return (
    <StyledTableCell>
      <InfoBadge>{listType}</InfoBadge>
    </StyledTableCell>
  );
};
